import { useField } from 'formik'
import { UsersProfiles1 } from 'blaze-ui/icons'
import { Field } from './Field'
import { Input } from 'almanac-ui/TextInputField/Input'

export const AudienceField = () => {
  const [field, meta, helpers] = useField<string>('audience')

  return (
    <Field icon={UsersProfiles1} label="Audience">
      <Input
        isTextarea
        value={field.value}
        onChange={(e) => helpers.setValue(e.target.value)}
        placeholder="Enter an audience for the campaign"
        isValid={!meta.touched || !meta.error}
        errorMessage={meta.touched && meta.error}
        name="audience"
      />
    </Field>
  )
}
